import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=17853f76&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17853f76')) {
      api.createRecord('17853f76', component.options)
    } else {
      api.reload('17853f76', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=17853f76&", function () {
      api.rerender('17853f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/comp/ImgFallback.vue"
export default component.exports